<div class="toast-message" *ngIf="message">
  <span class="info-icon"></span>
  <span>{{ message }}</span>
</div>